/* tslint:disable */
/* eslint-disable */
/**
 * BuLLy documentation
 * BuLLy Server
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redcare-pharmacy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setSearchParams, toPathString, createRequestFunction } from '../common.js';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from '../base.js';
/**
 * ContentControllerV3Api - axios parameter creator
 */
export const ContentControllerV3ApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} code PathParam code
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageContentV3TenantBlocksCodeGet: (code_1, tenant_1, language_1, ...args_1) => __awaiter(this, [code_1, tenant_1, language_1, ...args_1], void 0, function* (code, tenant, language, options = {}) {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('languageContentV3TenantBlocksCodeGet', 'code', code);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageContentV3TenantBlocksCodeGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageContentV3TenantBlocksCodeGet', 'language', language);
            const localVarPath = `/{language}/content/v3/{tenant}/blocks/{code}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} categoryCode
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageContentV3TenantCategoryUrlPathByCodeCategoryCodeGet: (categoryCode_1, tenant_1, language_1, ...args_1) => __awaiter(this, [categoryCode_1, tenant_1, language_1, ...args_1], void 0, function* (categoryCode, tenant, language, options = {}) {
            // verify required parameter 'categoryCode' is not null or undefined
            assertParamExists('languageContentV3TenantCategoryUrlPathByCodeCategoryCodeGet', 'categoryCode', categoryCode);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageContentV3TenantCategoryUrlPathByCodeCategoryCodeGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageContentV3TenantCategoryUrlPathByCodeCategoryCodeGet', 'language', language);
            const localVarPath = `/{language}/content/v3/{tenant}/category-url-path-by-code/{categoryCode}`
                .replace(`{${"categoryCode"}}`, encodeURIComponent(String(categoryCode)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} categoryCode
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageContentV3TenantNodesByCodeCategoryCodeGet: (categoryCode_1, tenant_1, language_1, ...args_1) => __awaiter(this, [categoryCode_1, tenant_1, language_1, ...args_1], void 0, function* (categoryCode, tenant, language, options = {}) {
            // verify required parameter 'categoryCode' is not null or undefined
            assertParamExists('languageContentV3TenantNodesByCodeCategoryCodeGet', 'categoryCode', categoryCode);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageContentV3TenantNodesByCodeCategoryCodeGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageContentV3TenantNodesByCodeCategoryCodeGet', 'language', language);
            const localVarPath = `/{language}/content/v3/{tenant}/nodes-by-code/{categoryCode}`
                .replace(`{${"categoryCode"}}`, encodeURIComponent(String(categoryCode)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} path PathParam path
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageContentV3TenantNodesPathGet: (path_1, tenant_1, language_1, ...args_1) => __awaiter(this, [path_1, tenant_1, language_1, ...args_1], void 0, function* (path, tenant, language, options = {}) {
            // verify required parameter 'path' is not null or undefined
            assertParamExists('languageContentV3TenantNodesPathGet', 'path', path);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageContentV3TenantNodesPathGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageContentV3TenantNodesPathGet', 'language', language);
            const localVarPath = `/{language}/content/v3/{tenant}/nodes/{path}`
                .replace(`{${"path"}}`, encodeURIComponent(String(path)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} code PathParam code
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageContentV3TenantPageCodeGet: (code_1, tenant_1, language_1, ...args_1) => __awaiter(this, [code_1, tenant_1, language_1, ...args_1], void 0, function* (code, tenant, language, options = {}) {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('languageContentV3TenantPageCodeGet', 'code', code);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageContentV3TenantPageCodeGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageContentV3TenantPageCodeGet', 'language', language);
            const localVarPath = `/{language}/content/v3/{tenant}/page/{code}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageContentV3TenantPagesGet: (tenant_1, language_1, ...args_1) => __awaiter(this, [tenant_1, language_1, ...args_1], void 0, function* (tenant, language, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageContentV3TenantPagesGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageContentV3TenantPagesGet', 'language', language);
            const localVarPath = `/{language}/content/v3/{tenant}/pages/}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} path PathParam path
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageContentV3TenantRoutePathGet: (path_1, tenant_1, language_1, ...args_1) => __awaiter(this, [path_1, tenant_1, language_1, ...args_1], void 0, function* (path, tenant, language, options = {}) {
            // verify required parameter 'path' is not null or undefined
            assertParamExists('languageContentV3TenantRoutePathGet', 'path', path);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageContentV3TenantRoutePathGet', 'tenant', tenant);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageContentV3TenantRoutePathGet', 'language', language);
            const localVarPath = `/{language}/content/v3/{tenant}/route/{path}`
                .replace(`{${"path"}}`, encodeURIComponent(String(path)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ContentControllerV3Api - functional programming interface
 */
export const ContentControllerV3ApiFp = function (configuration) {
    const localVarAxiosParamCreator = ContentControllerV3ApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} code PathParam code
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageContentV3TenantBlocksCodeGet(code, tenant, language, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageContentV3TenantBlocksCodeGet(code, tenant, language, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ContentControllerV3Api.languageContentV3TenantBlocksCodeGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} categoryCode
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageContentV3TenantCategoryUrlPathByCodeCategoryCodeGet(categoryCode, tenant, language, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageContentV3TenantCategoryUrlPathByCodeCategoryCodeGet(categoryCode, tenant, language, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ContentControllerV3Api.languageContentV3TenantCategoryUrlPathByCodeCategoryCodeGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} categoryCode
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageContentV3TenantNodesByCodeCategoryCodeGet(categoryCode, tenant, language, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageContentV3TenantNodesByCodeCategoryCodeGet(categoryCode, tenant, language, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ContentControllerV3Api.languageContentV3TenantNodesByCodeCategoryCodeGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} path PathParam path
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageContentV3TenantNodesPathGet(path, tenant, language, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageContentV3TenantNodesPathGet(path, tenant, language, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ContentControllerV3Api.languageContentV3TenantNodesPathGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} code PathParam code
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageContentV3TenantPageCodeGet(code, tenant, language, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageContentV3TenantPageCodeGet(code, tenant, language, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ContentControllerV3Api.languageContentV3TenantPageCodeGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageContentV3TenantPagesGet(tenant, language, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageContentV3TenantPagesGet(tenant, language, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ContentControllerV3Api.languageContentV3TenantPagesGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} path PathParam path
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageContentV3TenantRoutePathGet(path, tenant, language, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageContentV3TenantRoutePathGet(path, tenant, language, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ContentControllerV3Api.languageContentV3TenantRoutePathGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * ContentControllerV3Api - factory interface
 */
export const ContentControllerV3ApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ContentControllerV3ApiFp(configuration);
    return {
        /**
         *
         * @param {ContentControllerV3ApiLanguageContentV3TenantBlocksCodeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageContentV3TenantBlocksCodeGet(requestParameters, options) {
            return localVarFp.languageContentV3TenantBlocksCodeGet(requestParameters.code, requestParameters.tenant, requestParameters.language, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ContentControllerV3ApiLanguageContentV3TenantCategoryUrlPathByCodeCategoryCodeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageContentV3TenantCategoryUrlPathByCodeCategoryCodeGet(requestParameters, options) {
            return localVarFp.languageContentV3TenantCategoryUrlPathByCodeCategoryCodeGet(requestParameters.categoryCode, requestParameters.tenant, requestParameters.language, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ContentControllerV3ApiLanguageContentV3TenantNodesByCodeCategoryCodeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageContentV3TenantNodesByCodeCategoryCodeGet(requestParameters, options) {
            return localVarFp.languageContentV3TenantNodesByCodeCategoryCodeGet(requestParameters.categoryCode, requestParameters.tenant, requestParameters.language, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ContentControllerV3ApiLanguageContentV3TenantNodesPathGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageContentV3TenantNodesPathGet(requestParameters, options) {
            return localVarFp.languageContentV3TenantNodesPathGet(requestParameters.path, requestParameters.tenant, requestParameters.language, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ContentControllerV3ApiLanguageContentV3TenantPageCodeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageContentV3TenantPageCodeGet(requestParameters, options) {
            return localVarFp.languageContentV3TenantPageCodeGet(requestParameters.code, requestParameters.tenant, requestParameters.language, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ContentControllerV3ApiLanguageContentV3TenantPagesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageContentV3TenantPagesGet(requestParameters, options) {
            return localVarFp.languageContentV3TenantPagesGet(requestParameters.tenant, requestParameters.language, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ContentControllerV3ApiLanguageContentV3TenantRoutePathGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageContentV3TenantRoutePathGet(requestParameters, options) {
            return localVarFp.languageContentV3TenantRoutePathGet(requestParameters.path, requestParameters.tenant, requestParameters.language, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ContentControllerV3Api - object-oriented interface
 */
export class ContentControllerV3Api extends BaseAPI {
    /**
     *
     * @param {ContentControllerV3ApiLanguageContentV3TenantBlocksCodeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageContentV3TenantBlocksCodeGet(requestParameters, options) {
        return ContentControllerV3ApiFp(this.configuration).languageContentV3TenantBlocksCodeGet(requestParameters.code, requestParameters.tenant, requestParameters.language, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ContentControllerV3ApiLanguageContentV3TenantCategoryUrlPathByCodeCategoryCodeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageContentV3TenantCategoryUrlPathByCodeCategoryCodeGet(requestParameters, options) {
        return ContentControllerV3ApiFp(this.configuration).languageContentV3TenantCategoryUrlPathByCodeCategoryCodeGet(requestParameters.categoryCode, requestParameters.tenant, requestParameters.language, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ContentControllerV3ApiLanguageContentV3TenantNodesByCodeCategoryCodeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageContentV3TenantNodesByCodeCategoryCodeGet(requestParameters, options) {
        return ContentControllerV3ApiFp(this.configuration).languageContentV3TenantNodesByCodeCategoryCodeGet(requestParameters.categoryCode, requestParameters.tenant, requestParameters.language, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ContentControllerV3ApiLanguageContentV3TenantNodesPathGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageContentV3TenantNodesPathGet(requestParameters, options) {
        return ContentControllerV3ApiFp(this.configuration).languageContentV3TenantNodesPathGet(requestParameters.path, requestParameters.tenant, requestParameters.language, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ContentControllerV3ApiLanguageContentV3TenantPageCodeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageContentV3TenantPageCodeGet(requestParameters, options) {
        return ContentControllerV3ApiFp(this.configuration).languageContentV3TenantPageCodeGet(requestParameters.code, requestParameters.tenant, requestParameters.language, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ContentControllerV3ApiLanguageContentV3TenantPagesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageContentV3TenantPagesGet(requestParameters, options) {
        return ContentControllerV3ApiFp(this.configuration).languageContentV3TenantPagesGet(requestParameters.tenant, requestParameters.language, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ContentControllerV3ApiLanguageContentV3TenantRoutePathGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageContentV3TenantRoutePathGet(requestParameters, options) {
        return ContentControllerV3ApiFp(this.configuration).languageContentV3TenantRoutePathGet(requestParameters.path, requestParameters.tenant, requestParameters.language, options).then((request) => request(this.axios, this.basePath));
    }
}
